import { createContext, useContext } from 'react';
import { DisplayedDocument, DocumentPreview } from './types';

let documentPreview: DocumentPreview | undefined;
const setDocumentPreview: React.Dispatch<
    React.SetStateAction<DocumentPreview | undefined>
> = () => {};

const previewLoading: boolean = false;
const setPreviewLoading: React.Dispatch<React.SetStateAction<boolean>> = () => {};

const listDocuments: DisplayedDocument[] = [];
const setListDocuments: React.Dispatch<React.SetStateAction<DisplayedDocument[]>> = () => [];

const DocumentPreviewContext = createContext({
    previewLoading,
    setPreviewLoading,
    documentPreview,
    setDocumentPreview,
    listDocuments,
    setListDocuments,
});

export const useDocumentPreviewContext = () => useContext(DocumentPreviewContext);

export default DocumentPreviewContext;
